module.exports = __webpack_public_path__ + "static/media/red-shirt-band.c3a016c1.jpg";